import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const DollarIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 56 56"
			fill="none"
			className={props.className}
			width={props.width || '56'}
			height={props.height || '56'}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<rect x="4" y="4" width="48" height="48" rx="24" fill="#F4EBFF" />
			<path
				d="M29.19 18.56V19.69C29.19 19.8 29.19 19.8 29.29 19.8C29.6 19.8 30.53 19.91 30.84 19.91C31.35 20.02 31.97 20.13 32.38 20.25C32.59 20.36 32.69 20.58 32.69 20.81V22.72C32.69 23.06 32.18 23.39 31.87 23.17H31.66L30.73 22.83C30.42 22.72 30.11 22.72 29.8 22.61C29.49 22.61 29.19 22.49 28.98 22.49C28.57 22.49 28.26 22.49 27.95 22.61C27.64 22.72 27.43 22.83 27.23 22.94C27.02 23.06 26.81 23.28 26.71 23.39C26.61 23.62 26.51 23.84 26.51 24.07C26.51 24.29 26.61 24.63 26.71 24.74C26.81 24.97 27.02 25.19 27.23 25.3C27.43 25.53 27.74 25.64 28.05 25.87C28.36 26.09 28.77 26.2 29.19 26.43C29.8 26.65 30.32 26.99 30.73 27.33C31.25 27.66 31.56 28 31.97 28.34C32.38 28.67 32.59 29.12 32.69 29.57C32.9 30.02 33 30.58 33 31.26C33 32.16 32.9 32.83 32.59 33.51C32.28 34.07 31.87 34.63 31.35 34.97C30.84 35.3 30.11 35.64 29.49 35.75H29.08V36.88C29.08 37.21 29.19 38 28.05 38H27.23C26.4 38 26.09 37.66 26.09 36.99V35.87C26.09 35.87 25.27 35.75 24.65 35.64C24.03 35.53 23.72 35.3 23.52 35.08C22.9 34.63 23.21 31.37 24.03 31.93C24.44 32.16 24.65 32.38 25.06 32.49C25.78 32.72 26.4 32.94 27.12 32.94C27.54 32.94 27.95 32.94 28.15 32.83C28.46 32.72 28.77 32.61 28.98 32.49C29.19 32.38 29.39 32.16 29.39 31.93C29.49 31.71 29.6 31.48 29.6 31.26C29.6 30.92 29.49 30.7 29.39 30.47C29.19 30.25 28.98 30.02 28.67 29.8C28.36 29.57 28.05 29.35 27.64 29.24C27.23 29.01 26.81 28.9 26.4 28.67C25.27 28.11 24.44 27.55 23.82 26.76C23.31 25.98 23 25.08 23 24.07C23 23.28 23.1 22.49 23.41 21.93C23.72 21.37 24.13 20.81 24.65 20.47C25.16 20.13 25.16 20.02 25.89 19.69C25.99 19.69 25.99 19.57 25.99 19.57V18.56C25.99 18.34 26.2 18 26.61 18H28.36C28.88 18.11 29.19 18.34 29.19 18.56Z"
				fill="#6941C6"
			/>
			<rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9F5FF" strokeWidth="8" />
		</svg>
	)
}

export default DollarIcon
